import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useProgressStore = defineStore('progress', () => {
  const currentStep = ref(1);

  function setCurrentStep(step: number) {
    currentStep.value = step;
  }

  return {
    currentStep,
    setCurrentStep,
  };
});
